<div class="card">
    <form class="g-3" name="ShiftForm" (ngSubmit)="Validate(ShiftForm)" #ShiftForm="ngForm" novalidate>
        <div class="card-header">
            Shift Master
        </div>
        <div class="card-body">
            <div class="row pb-2">
                <div class="col-md-4">
                    <label for="ShiftCode" class="form-font-label">Shift Code<span class="text-danger">*</span></label>
                    <input type="text" minlength="3" maxlength="10" class="form-control" placeholder="Ex. XYZ"
                        id="ShiftCode" name="ShiftCode" [(ngModel)]="ShiftDetail.ShiftCode" #ShiftTitle="ngModel"
                        required [disabled]="ShiftDetail.ShiftMasterid > 0">
                    <div class="invalid-feedback">
                        Please enter shift Code!
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="ShiftTitle" class="form-font-label">Shift Name<span class="text-danger">*</span></label>
                    <input type="text" maxlength="100" class="form-control" placeholder="Ex. Morning" id="ShiftTitle"
                        name="ShiftTitle" [(ngModel)]="ShiftDetail.ShiftTitle" #ShiftTitle="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter shift Name!
                    </div>
                </div>
                <div class="col-md-auto" *ngIf="this.common.CompanyParameterValue.IsShiftRuleFromShiftMaster">
                    <button type="button" class="btn btn-outline-secondary mt-4" [disabled]="isDisabled"
                    (click)="ShiftMasterPolicy()">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'View Detail':'Loading...'}}</button>
                </div>
                <!-- <div class="col-md-6">
                    <label for="ShiftCode" class="form-font-label">Shift Code</label>
                    <input type="text" maxlength="8" class="form-control" placeholder="Ex. S001" id="ShiftCode"
                        name="ShiftCode" [(ngModel)]="ShiftDetail.ShiftCode" #ShiftCode="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter shift code!
                    </div>
                </div> -->
            </div>
            <div class="row pb-2">
                &nbsp;&nbsp; <div class="col-md-4 px-1">
                    <label class="Label">Shift Group<span class="text-danger">*</span></label>
                    <ng-select [items]="ShiftGroup" bindLabel="ShiftGroupName" bindValue="ESS_ShiftGroupMasterId"
                        placeholder="Select Shift Group" [(ngModel)]="ShiftDetail.ESS_ShiftGroupMasterID" name="shiftgroup"
                        required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Shift Group.
                    </div>
                </div>
            </div>
            <div class="row pb-2">
                <div class="col-md-6 d-inline-flex align-items-sm-center">
                    <label for="FromTime" class="form-font-label pe-2">From Time : </label>
                    <ngb-timepicker (change)="timeFormate($event,'FromTime')" name="FromTime"
                        [(ngModel)]="ShiftDetail.InTimeObj" #FromTime="ngModel" />
                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                        [ngbTooltip]="tooltip.Message24hr"></i>
                    <div class="invalid-feedback">
                        Please enter from time!
                    </div>
                </div>
                <div class="col-md-6 d-inline-flex align-items-sm-center">
                    <label for="ToTime" class="form-font-label pe-2">To Time : </label>
                    <ngb-timepicker name="ToTime" (change)="timeFormate($event,'ToTime')"
                        [(ngModel)]="ShiftDetail.OutTimeObj" #ToTime="ngModel" />
                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                        [ngbTooltip]="tooltip.Message24hr"></i>
                    <div class="invalid-feedback">
                        Please enter to time!
                    </div>
                </div>
            </div>
            <div class="row pb-2">
                <div class="col-md-6">
                    <label for="DefaultShift" class="form-font-label">Default Shift : </label>
                    <div class="btn-group btn-group-toggle">
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]=true name='DefaultShift'
                                [(ngModel)]="ShiftDetail.DefaultShift" [ngModelOptions]="{standalone: true}">
                            Yes
                        </label>
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]=false name='DefaultShift'
                                [(ngModel)]="ShiftDetail.DefaultShift" [ngModelOptions]="{standalone: true}">
                            No
                        </label>
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="RotationalShift" class="form-font-label">Rotational Shift : </label>
                    <div class="btn-group btn-group-toggle">
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]=true name='RotationalShift'
                                [(ngModel)]="ShiftDetail.RotationalShift" [ngModelOptions]="{standalone: true}">
                            Yes
                        </label>
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]=false name='RotationalShift'
                                [(ngModel)]="ShiftDetail.RotationalShift" [ngModelOptions]="{standalone: true}">
                            No
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button
                    *ngIf="(this.common.PageRight.IsAdd && this.ShiftDetail.ShiftMasterid == 0) || (this.common.PageRight.IsEdit && this.ShiftDetail.ShiftMasterid > 0)"
                    type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>